class AuthorDetail {
    constructor(authorDetailComponentElement) {
        this.authorDetailComponentElement = authorDetailComponentElement;
    }

    init() {
        console.log('init AuthorDetail Component')
    }
}

export default function init() {
    const authorDetailComponentElements = document.querySelectorAll('.author-detail-v2-component');

    authorDetailComponentElements.forEach(authorDetailComponentElement => {
        const authorDetailComponent = new AuthorDetail(authorDetailComponentElement);
        authorDetailComponent.init()
    });
}
